import { Box, Paper, styled } from '@mui/material';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import useIsDesktop from 'reservations/base/hooks/useIsDesktop';

type ImageProps = {
  isDesktop: boolean;
};
const Image = styled('img')<ImageProps>(({ isDesktop }) => ({
  objectFit: 'contain',
  minHeight: '70px',
  maxHeight: '120px',
  minWidth: '70px',
  maxWidth: isDesktop ? '560px' : '300px'
}));

export const LogoOnlyLayout = () => {
  const { logo } = useAccount();
  const isDesktop = useIsDesktop();
  return (
    <Box
      data-testid="logo-only-layout"
      sx={{
        width: '100%',
        display: 'grid',
        justifyContent: 'start'
      }}
    >
      <Paper
        data-testid="logo-wrapper"
        sx={{
          backgroundColor: 'transparent',
          width: 'inherit',
          boxShadow: 0
        }}
      >
        <Image
          isDesktop={isDesktop}
          src={logo.url}
          alt={logo.alt_text}
          data-testid="logo-image"
        />
      </Paper>
    </Box>
  );
};
